import { useEffect, useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import SidebarLayout from '../../layouts/SidebarLayout';
import PickDoctorSchedule from './components/PickDoctorSchedule/PickDoctorSchedule';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../store/loader';
import { useDoctorService } from '../../hooks';
import { Doctor } from '../../../domain/entities';

const DoctorScheduler = () => {
  const DoctorService = useDoctorService();
  const dispatch = useDispatch();
  const [doctorName, setDoctorName] = useState<string>('');
  const [doctors, setDoctors] = useState<Doctor[]>([]);

  const isLoading = (state: boolean) => dispatch(loaderActions.setLoading(state));

  const changeDoctorName = (e: React.ChangeEvent<HTMLInputElement>) =>
    setDoctorName(e.target.value);

  useEffect(() => {
    isLoading(true);

    DoctorService.listAll()
      .then((doctors) => setDoctors(doctors))
      .catch((e) => console.log(e))
      .finally(() => isLoading(false));
  }, []);

  return (
    <SidebarLayout>
      <h2>Buscar Doctor:</h2>
      <TextField
        id='doctorName'
        label='Nombre'
        value={doctorName}
        onChange={changeDoctorName}
        autoComplete='off'
        InputProps={{
          endAdornment: (
            <Button type='submit' variant='contained' color='primary'>
              Buscar
            </Button>
          )
        }}
      />
      <Box sx={{ paddingTop: 2 }}>
        {doctors.map((doctor) => (
          <PickDoctorSchedule key={doctor.id} doctor={doctor} />
        ))}
      </Box>
    </SidebarLayout>
  );
};

export default DoctorScheduler;
